import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.splice.js";
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import useList from './hooks/useList';
import useOaToken from './hooks/useOaToken';
import dayjs from 'dayjs';
import ReleaseItem from './cpns/ReleaseItem.vue';
import useUserInfo from '../ApplyRequisition/hooks/useUserInfo';
export default defineComponent({
  name: 'SelectWarehouse',
  components: {
    ReleaseItem: ReleaseItem
  },
  setup: function setup() {
    var formatDate = function formatDate(date) {
      return dayjs(date).format('YYYY/MM/DD');
    };
    var route = useRoute();
    var params = ref({
      page: 1,
      limit: 10,
      u_name: '',
      stone_name: '',
      start_time: dayjs().format('YYYY/MM/DD 00:00:00'),
      end_time: dayjs().format('YYYY/MM/DD 23:59:59'),
      release_status: '' //0未审核 1审核中  2 待出库 3已驳回  4已出库
    });
    //获取当前用户名
    var _useUserInfo = useUserInfo(),
      _useUserInfo2 = _slicedToArray(_useUserInfo, 2),
      useInfo = _useUserInfo2[0],
      getUserInfoAsync = _useUserInfo2[1];
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUserInfoAsync();
          case 2:
            params.value.u_name = useInfo.value.u_name;
            // params.value.u_name = '张彦彦'
            getReleaseListAsync();
            getOATokenAsync();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var onSearch = function onSearch() {
      //页码重置为1 list清空
      params.value.page = 1;
      list.value.splice(0);
      loading.value = true;
      finished.value = false;
      getReleaseListAsync();
    };
    var _useList = useList(params),
      _useList2 = _slicedToArray(_useList, 5),
      list = _useList2[0],
      loading = _useList2[1],
      finished = _useList2[2],
      getReleaseListAsync = _useList2[3],
      onLoad = _useList2[4];
    var params1 = computed(function () {
      return {
        loginid: params.value.u_name
      };
    });
    var _useOaToken = useOaToken(params1),
      _useOaToken2 = _slicedToArray(_useOaToken, 2),
      oaToken = _useOaToken2[0],
      getOATokenAsync = _useOaToken2[1];
    var show = ref(false);
    var maxDate = ref(new Date());
    var minDate = ref(new Date(dayjs().subtract(7, 'year').format('YYYY/MM/DD')));
    var confirmDate = function confirmDate(value) {
      show.value = false;
      params.value.start_time = dayjs(value[0]).format('YYYY/MM/DD 00:00:00');
      params.value.end_time = dayjs(value[1]).format('YYYY/MM/DD 23:59:59');
      params.value.page = 1;
      list.value.splice(0);
      loading.value = true;
      finished.value = false;
      getReleaseListAsync();
    };
    var showCalendar = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              show.value = true;
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function showCalendar() {
        return _ref2.apply(this, arguments);
      };
    }();
    var tabs = ref([{
      name: '所有',
      value: ''
    }, {
      name: '审核中',
      value: '1'
    }, {
      name: '待出库',
      value: '2'
    }, {
      name: '已出库',
      value: '4'
    }, {
      name: '已驳回',
      value: '3'
    }]);
    var tabActive = ref(0);
    var tabClick = function tabClick(item, index) {
      tabActive.value = index;
      // //tab切换时清空数组
      // list.value.splice(0)
      params.value.release_status = item.value;
      onSearch();
    };
    return {
      params: params,
      onSearch: onSearch,
      list: list,
      loading: loading,
      finished: finished,
      onLoad: onLoad,
      showCalendar: showCalendar,
      maxDate: maxDate,
      minDate: minDate,
      show: show,
      confirmDate: confirmDate,
      tabs: tabs,
      tabActive: tabActive,
      tabClick: tabClick,
      oaToken: oaToken,
      formatDate: formatDate
    };
  }
});